import { Icon } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'
import groupBy from 'lodash/groupBy'
import keys from 'lodash/keys'
import moment from 'moment'

import Emoji from 'modules/calendar/components/Emoji'
import type CalendarEvent from 'modules/calendar/store/models/CalendarEvent'

import emojiMap from 'modules/calendar/components/Calendar/components/emojiMap'
import styles from './styles/index.module.css'

const cx = classNames.bind(styles)

interface Props {
  events: CalendarEvent[]
  holidays: CalendarEvent[]
  day: moment.Moment
  isAnotherMonth: boolean
}

const MonthHeader = ({ day, holidays, isAnotherMonth, events }: Props) => {
  const renderEmoji = (type: string | null | undefined) => {
    if (!type) {
      return <Icon.Medium icon="ellipsis" />
    }

    const emojiName = emojiMap[type]

    return (
      emojiName && (
        <div className={styles.emoji}>
          <Emoji size="small" name={emojiName} />
        </div>
      )
    )
  }

  const renderEvents = () => {
    const groupedEvents = groupBy(events, (event) => event.attributes.type)
    const types = keys(groupedEvents)

    if (!types.length) return null

    const type = types.length === 1 ? types[0] : null

    return (
      <div className={styles.event}>
        <div className={styles.emoji}>{renderEmoji(type)}</div>
        <div className={styles.numUsers}>{events.length}</div>
      </div>
    )
  }

  const classNames = cx('day', {
    today: day.isSame(moment(), 'day'),
    sunday: day.day() === 0,
    saturday: day.day() === 6,
    otherMonth: isAnotherMonth,
    hasHolidays: !!holidays.length,
  })

  const date = day.format('D')

  return (
    <div className={classNames}>
      <div className={styles.dayContent}>
        <div className={styles.dayNumber}>{date === '1' ? day.format('MMM D') : date}</div>
        {renderEvents()}
      </div>
    </div>
  )
}

export default MonthHeader
